// DiscoverFlixMore.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import DiscoverFlixMore from '../component/DiscoverFlixMore.jsx';
import getMeData from '../selector/getMeData.js';
import fetchFeeds from '../action/fetchFeeds.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchUser from '../action/fetchUser.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPaginationData from '../selector/getPaginationData.js';
import getUserListFromFeed from '../selector/getUserListFromFeed.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import { FeedNameType } from '../resource/feedConstants.js';
import { getFeedCategory, sanitizeFeedQuery } from '../resource/feedUtils.js';
import getTranslationKey from '../resource/getTranslationKey.js';

import { PAGINATION_ITEM_COUNT_PER_PAGE } from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { category: paramCategory },
    },
  }
) => {
  const limit = getRemoteConfigData(state, PAGINATION_ITEM_COUNT_PER_PAGE);
  const { search } = location;
  const searchParmas = new URLSearchParams(search);
  const currentPage = Number(searchParmas.get('page')) || 1;
  const category = getFeedCategory({
    category: paramCategory,
    search,
  });
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
  const selectPath = ['home', FeedNameType.MESSAGES, sanitizedCategory];
  const senderIds = getUserListFromFeed(state, selectPath, 'itemIds');
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const messageIds = getPaginationData(
    state,
    selectPath,
    'itemIds',
    undefined,
    limit,
    currentPage
  );
  const totalCount = getPaginationData(state, selectPath, 'totalCount');
  return {
    category,
    titleI18nId: getTranslationKey({ key: category }),
    isAuthed: !!getMeData(state, 'id'),
    limit,
    currentPage,
    totalCount,
    messageIds,
    isCurrentPageFetched: !!getNetworkingData(
      state,
      [...selectPath, currentPage, limit],
      'isFetched'
    ),
    isFirstPageFetched: getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    isFirstMessageDetailFetched: getNetworkingData(
      state,
      ['messages', messageIds?.[0], 'detail'],
      'isFetched'
    ),
    senderIds,
    isFirstSenderDataFetched: getNetworkingData(
      state,
      ['user', senderIds?.[0]],
      'isFetched'
    ),
    deviceWidth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    fetchMessageDetail: ({ id, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id, httpProxyHeaders })),
    fetchUser: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUser({ id: userId, httpProxyHeaders })),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverFlixMore);
